// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"ced9fa77","796":"5feb0779"}[chunkId] + ".chunk.js";
};